import React from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useTranslation } from 'react-i18next'
import { THEME } from 'components/theme'

// The one "NEW" pill used everywhere a feature is tagged as new (sidebar tabs,
// the ledger "+" pill, the Settings UPI QR row). Rules for when it shows live in
// utils/featureTags; this is only the look.
const useStyles = createUseStyles({
  tag: {
    display: 'inline-block',
    padding: '1px 6px',
    borderRadius: 8,
    backgroundColor: THEME.brandRed,
    color: THEME.onBrand,
    fontSize: 9,
    lineHeight: '14px',
    fontWeight: 700,
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
    maxWidth: 44,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
    pointerEvents: 'none'
  },
  // Sits on the top-right corner of its (position: relative) parent
  corner: {
    position: 'absolute',
    top: -6,
    right: -12
  }
})

interface INewTag {
  // Corner overlay (default) or inline next to text
  placement?: 'corner' | 'inline'
  className?: string
}

const NewTag: React.FC<INewTag> = ({ placement = 'corner', className }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <span
      className={classNames(classes.tag, { [classes.corner]: placement === 'corner' }, className)}
    >
      {t('dashboard:NEW')}
    </span>
  )
}

export default NewTag
